import { render, staticRenderFns } from "./Auth.vue?vue&type=template&id=6ed6d953&scoped=true"
import script from "./Auth.vue?vue&type=script&setup=true&lang=js"
export * from "./Auth.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Auth.vue?vue&type=style&index=0&id=6ed6d953&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed6d953",
  null
  
)

export default component.exports